
import React from 'react';
import { CheckCircle, Zap, Smartphone, Settings, Rocket, MousePointer, Users } from 'lucide-react';
import ScrollReveal from '../ui/ScrollReveal';

const CoreValueSection = () => {
  const values = [
    {
      icon: <CheckCircle className="h-8 w-8 text-emerald-500" />,
      title: "Human-written homepage copy included",
      description: "Tailored to your voice and brand personality"
    },
    {
      icon: <Zap className="h-8 w-8 text-yellow-500" />,
      title: "Lightning-fast speed & modern code",
      description: "Framer-based websites that load in milliseconds"
    },
    {
      icon: <Smartphone className="h-8 w-8 text-blue-500" />,
      title: "100% responsive design",
      description: "Perfect on desktop, tablet, and mobile devices"
    },
    {
      icon: <Settings className="h-8 w-8 text-purple-500" />,
      title: "We handle hosting & monthly maintenance",
      description: "Worry-free website management and updates"
    },
    {
      icon: <Rocket className="h-8 w-8 text-red-500" />,
      title: "Ongoing SEO & content marketing available",
      description: "Drive more traffic and leads to your business"
    },
    {
      icon: <MousePointer className="h-8 w-8 text-green-500" />,
      title: "Revisions made super easy",
      description: "Point & click directly on your website to request changes"
    },
    {
      icon: <Users className="h-8 w-8 text-indigo-500" />,
      title: "No-login client portal",
      description: "Track tasks, files, comments & project stages easily"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <ScrollReveal>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-semibold mb-4">
              What Makes Our Websites Stand Out
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={150}>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We don't just build websites — we create digital experiences that showcase your brand at its absolute best.
            </p>
          </ScrollReveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <ScrollReveal key={index} delay={150 * (index % 3)}>
              <div className="relative bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-100 hover:border-gray-200 hover:shadow-lg transition-all duration-300 group">
                <div className="absolute top-4 right-4 opacity-10 group-hover:opacity-20 transition-opacity">
                  {value.icon}
                </div>
                <div className="mb-4">
                  {value.icon}
                </div>
                <h3 className="text-xl font-semibold mb-3 text-gray-900">
                  {value.title}
                </h3>
                <p className="text-gray-600">
                  {value.description}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreValueSection;
